
jQuery(document).ready(function($){
    $('.image-gallery').lightSlider({ 
    gallery:false, 
    item:1, //number of slides to show at a time
    mode: "fade",
    useCSS: true,
    cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
    pause: 3000,
    speed: 4000, //ms'
    auto:true, 
    loop:true,
    slideEndAnimation: true, 
    thumbItem: 9,
    item:1,
    pauseOnHover: true,
    slideMargin: 0,
    autoWidth: true,
    controls: false,
    pager:false,
    adaptiveHeight: false, // disables auto-height
    // onSliderLoad: function() {
    //     $('#light-slider').css('height', '600px');
    // }
    });
    });

// new ModalVideo('.js-modal-btn', {channel: 'vimeo'});
jQuery(document).ready(function($) {

$(".js-video-button").modalVideo({
  channel: 'vimeo',
  vimeo: {
    api: false,
    autopause: true,
    autoplay: true,
    byline: true,
    callback: null,
    color: 'red',
    height: null,
    loop: true,
    maxheight: null,
    maxwidth: null,
    muted: false,
    player_id: null,
    portrait: true,
    title: true,
    width: 2000,
    xhtml: false
  },
  ratio: '16:9',
  allowFullScreen: true,
  animationSpeed: 300,
  classNames: {
    modalVideo: 'modal-video',
    modalVideoClose: 'modal-video-close',
    modalVideoBody: 'modal-video-body',
    modalVideoInner: 'modal-video-inner',
    modalVideoIframeWrap: 'modal-video-movie-wrap',
    modalVideoCloseBtn: 'modal-video-close-btn'
  },
  aria: {
    openMessage: 'You just openned the modal video',
    dismissBtnMessage: 'Close the modal by clicking here'
  }
});



});



  // // Smooth Scroll from slider to Nav
  //     jQuery("#arrow").click(function() {
  //       $('html, body').animate({
  //           scrollTop: $("#main-nav").offset().top
  //       }, 1000);
  //   });

/*------------------------------------------------------------------------------------------------------------------------------
*
* Reveal Mobile Menu dropdown
*
*/

jQuery(document).ready(function($) {
$("#mobile-menu").click(function(){
  $(".menu-main-menu-container").slideToggle();
});
});
